var React = require("react");
var SelectDropdown = require("patternity/lib/select_dropdown");
var { withNamespaces } = require('react-i18next');

var ChallengeFilters = React.createClass({
  propTypes: {
    challengeTypes: React.PropTypes.array.isRequired,
    onChange: React.PropTypes.func.isRequired,
    selectedChallengeType : React.PropTypes.string.isRequired,
  },

  getDefaultProps: function() {
    return {
      challengeTypes : [],
      onChange : function(){},
      selectedChallengeType : ""
    };
  },

  render: function() {
    return (
      <div className='filter-dropdown pt-override'>
        <label htmlFor="challenge-filter-select" style={{margin: 0}}>
          <SelectDropdown id="challenge-filter" key="challenge-filter-types"
            onChange={this._onChallengeTypeChange}
            value={this.props.selectedChallengeType}>
            <option key="key0" value="">{this.props.t('Filter by Category')}</option>
            { this._renderChallengeTypes() }
          </SelectDropdown>
        </label>
      </div>
    );
  },

  _renderChallengeTypes: function() {
    return _.map(this.props.challengeTypes, function(type, index) {
      return ( <option key={type.filter} value={type.filter}>{type.name}</option> );
    });
  },

  _onChallengeTypeChange: function(event) {
    app.analytics.logEvent('Challenges Filtering', {filteringOption: event.target.value});
    this.props.onChange({type: event.target.value});
  }
});

module.exports = withNamespaces()(ChallengeFilters);



// WEBPACK FOOTER //
// ./src/advocate/challenges/components/filters.jsx